import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-magic-link-update-password-dialog',
    templateUrl: './magic-link-update-password-dialog.component.html',
    styleUrls: ['./magic-link-update-password-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class MagicLinkUpdatePasswordDialogComponent extends FiDialogsContentBase<void, string> implements OnInit {
    newPassword: string;
    showPassword = true;

    @ViewChild('newPasswordModel', { static: false }) newPasswordModel: NgModel;

    ngOnInit() {}

    isYesButtonDisabled() {
        return !this.newPasswordModel || !this.newPasswordModel.valid;
    }

    getResult() {
        return this.newPassword;
    }

    toggleShowPassword() {
        this.showPassword = !this.showPassword;
    }
}
